var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateTime, Duration } from "luxon";
import * as React from 'react';
import { NavLink } from "react-router-dom";
import { Button, Dimmer, Divider, Form, Grid, Header, Loader, Message, Modal, Segment, TextArea } from "semantic-ui-react";
import { displayLocalTimestamp } from "./admin/AllOrdersPage";
import SimpleFormWithErrorDisplay from "./admin/SimpleFormWithErrorDisplay";
import { AppPaths } from "./AppConfig";
import { deserializeQuote } from "./CartPage";
import { API_SVC_BASE_URL, ORIGIN } from "./Config";
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
import { Help } from "./Help";
import { MetaCatalogLoader } from "./kit/Catalog";
import { buildEditFormStateHandlerForComponent } from "./kit/FormState";
import { defaultIhc2FormState, EditKitForm as Ihc2EditKitForm, serializeIhc2Kit } from "./kit/ihc2/EditKitForm";
import { ihc2KitToFormState } from "./kit/ihc2/Ihc2KitToFormState";
import KitIndexHeader from "./kit/KitIndexHeader";
import { defaultEnzymaticIshFormState } from "./kit/rna-cish/NewProKitPage";
import ProKitForm from "./kit/rna-cish/ProKitForm";
import { RelevantCatalogType } from "./kit/rna-cish/RnaCatalog";
import { rnaCishKitToProFormState } from "./kit/rna-cish/RnaCishKitToProFormState";
import EditKitForm, { CART_PRICE_PATH, defaultFormState, discountMessage, formatMonetaryDecimal, } from "./kit/rna-fish/EditKitForm";
import KitDisplay from "./kit/rna-fish/KitDisplay";
import { BundleOfKits, PricedBundleOfKits, RnaCishKit, RnaFishKit, RnaFishPricedKit } from "./kit/rna-fish/KitModel";
import { LoadWrapper } from "./kit/rna-fish/LoadWrapper";
import { tagAddToCart } from "./kit/rna-fish/NewRnaFishKitPage";
import { rnaFishKitToFormState } from "./kit/rna-fish/RnaFishKitToFormState";
import KitDeserializer, { DetectOnly, ProbeDetect, ProbeOnly } from "./KitDeserializer";
import QuoteDisplay from "./QuoteDisplay";
import { CatalogMode, getWithAuthn, postJsonWithAuthn } from "./RequestHelpers";
import ChromogenKitForm from "./kit/rna-cish/ChromogenKitForm";
import { defaultChromogenKitFormState } from "./kit/rna-cish/NewChromogenKitPage";
import { chromogenOnlyCishKitToConsumerFormState } from "./kit/rna-cish/ChromogenOnlyCishKitToConsumerFormState";
import ManualProConsumerKitForm, { defaultFormState as defaultManualProConsumerFormState } from "./kit/bundle-of-kits/ManualProConsumerKitForm";
import { manualProKitToConsumerFormState } from "./kit/bundle-of-kits/ManualProKitToConsumerFormState";
var UserOrderPage = /** @class */ (function (_super) {
    __extends(UserOrderPage, _super);
    function UserOrderPage(props) {
        var _this = _super.call(this, props) || this;
        _this.displayItems = function (order) {
            return order.items.map(function (i, index) {
                return React.createElement(ItemWithReorderButton, { key: index, item: i, itemIndex: index, orderId: order.id });
            });
        };
        _this.editNicknameModal = function (order) {
            var renderEditNickname = function (props) {
                return React.createElement(EditNicknameModal, __assign({ order: order }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadOrder, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit order nickname', labelPosition: 'left' }) },
                React.createElement(Modal.Header, null, "Edit Nickname"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEditNickname, successMessage: 'Nickname saved' })));
        };
        _this.cancelOrder = function (order) {
            var renderCancelConfirmation = function (props) {
                return React.createElement(CancelOrderModal, __assign({ order: order }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadOrder, trigger: React.createElement(Button, { icon: 'edit', label: 'Cancel Order', labelPosition: 'left', disabled: order.status === "Complete" || order.status === "Cancelled" }) },
                order.cancellable &&
                    React.createElement(Modal.Header, null, "Are you sure you want to cancel this order?"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderCancelConfirmation, successMessage: 'Order Cancelled' })));
        };
        _this.loadOrder = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn("/user/orders/id/" + encodeURIComponent(_this.props.match.params.id))
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            response: {
                                order: __assign(__assign({}, resp.order), { items: resp.order.items.map(function (i) { return KitDeserializer.deserializePricedKit(i); }), lineItems: resp.order.lineItems.map(function (li) {
                                        // TS enums are dumb
                                        switch (li.type) {
                                            case LineItemType.Misc:
                                                return __assign(__assign({}, li), { type: LineItemType.Misc });
                                            case LineItemType.ShippingHandling:
                                                return __assign(__assign({}, li), { type: LineItemType.ShippingHandling });
                                            case LineItemType.Tax:
                                                return __assign(__assign({}, li), { type: LineItemType.Tax });
                                            default:
                                                throw new Error("Unexpected type: " + li.type);
                                        }
                                    }), quote: deserializeQuote(resp.order.quote) })
                            }
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load order: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false,
        };
        return _this;
    }
    UserOrderPage.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: "non-header-portion", as: 'div', className: 'user-order' },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Order could not be loaded."),
                this.state.response &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Header, null,
                            "Order ",
                            this.state.response.order.id,
                            this.state.response.order.modified ? ' (updated)' : ''),
                        React.createElement(Grid, { columns: 3 },
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement("div", null,
                                        "Status: ",
                                        this.state.response.order.status),
                                    React.createElement("div", null,
                                        "Created: ",
                                        displayLocalTimestamp(this.state.response.order.createdAt))),
                                React.createElement(Grid.Column, null,
                                    React.createElement("div", { className: 'shipping-billing-info' },
                                        React.createElement("strong", null, "Shipping Info"),
                                        React.createElement("p", null, this.state.response.order.shippingAddress.street),
                                        React.createElement("p", null,
                                            this.state.response.order.shippingAddress.city,
                                            ", ",
                                            this.state.response.order.shippingAddress.stateProvince,
                                            " ",
                                            this.state.response.order.shippingAddress.zipPostalCode),
                                        React.createElement("p", null, this.state.response.order.shippingAddress.countryCode))),
                                React.createElement(Grid.Column, null,
                                    React.createElement("div", { className: 'shipping-billing-info' },
                                        React.createElement("strong", null, "Billing Info"),
                                        React.createElement("p", null, this.state.response.order.billingAddress.street),
                                        React.createElement("p", null,
                                            this.state.response.order.billingAddress.city,
                                            ", ",
                                            this.state.response.order.billingAddress.stateProvince,
                                            " ",
                                            this.state.response.order.billingAddress.zipPostalCode),
                                        React.createElement("p", null, this.state.response.order.billingAddress.countryCode))))),
                        React.createElement(Divider, null),
                        React.createElement("div", { style: { paddingBottom: '0.7rem' } },
                            React.createElement("div", { style: { fontWeight: 'bold' } },
                                "Order nickname ",
                                nicknameHelp),
                            React.createElement("pre", { style: { display: 'inline' }, className: 'text-with-whitespace' }, this.state.response.order.nickname)),
                        this.editNicknameModal(this.state.response.order),
                        (this.state.response.order.status === "Submitted" || this.state.response.order.status === "In production") &&
                            React.createElement(React.Fragment, null,
                                React.createElement(Divider, null),
                                React.createElement("div", { style: { paddingBottom: '0.7rem' } },
                                    React.createElement("div", { style: { fontWeight: 'bold' } }, React.createElement("a", { href: API_SVC_BASE_URL + "/user/orders/id/" + encodeURIComponent(this.state.response.order.id) + "/quote-pdf", target: "_blank" },
                                        React.createElement(Button, { icon: 'download', label: 'Download Quote PDF', labelPosition: 'left' }))))),
                        (this.state.response.order.status === "Submitted" || this.state.response.order.status === "In production") &&
                            React.createElement(React.Fragment, null,
                                React.createElement(Divider, null),
                                React.createElement("div", { style: { paddingBottom: '0.7rem' } },
                                    React.createElement("div", { style: { fontWeight: 'bold' } }, this.cancelOrder(this.state.response.order)))),
                        React.createElement(Header, null, "Items"),
                        this.state.response && this.displayItems(this.state.response.order),
                        React.createElement("div", { className: 'price' },
                            React.createElement("table", null,
                                React.createElement("tbody", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", null,
                                            React.createElement(Header, null, "Order Subtotal (USD)")),
                                        React.createElement("td", { className: 'monetary' },
                                            React.createElement(Header, null,
                                                "$",
                                                formatMonetaryDecimal(this.state.response.order.kitSubtotalCents))),
                                        React.createElement("td", { className: 'spacer' })),
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 3 }, discountMessage(this.state.response.order.discountCents, this.state.response.order.listPricedKitSubtotalCents))),
                                    this.state.response.order.lineItems.map(function (li, index) {
                                        return React.createElement("tr", { key: index },
                                            React.createElement("td", null, li.note),
                                            React.createElement("td", { className: 'monetary' },
                                                "$",
                                                formatMonetaryDecimal(li.amountCents)));
                                    }),
                                    this.state.response.order.lineItems.length > 0 &&
                                        React.createElement("tr", null,
                                            React.createElement("td", null,
                                                React.createElement(Header, null, "Adjusted Subtotal (USD)")),
                                            React.createElement("td", { className: 'monetary' },
                                                React.createElement(Header, null,
                                                    "$",
                                                    formatMonetaryDecimal(this.state.response.order.adjustedSubtotalCents)))),
                                    this.state.response.order.lineItems.find(function (l) { return l.type === LineItemType.ShippingHandling; }) === undefined &&
                                        React.createElement(React.Fragment, null,
                                            React.createElement("tr", null,
                                                React.createElement("td", null, "Estimated Shipping"),
                                                React.createElement("td", { className: 'monetary' }, this.state.response.order.quote.shippingCostEstimate != null || this.state.response.order.quote.shippingCostEstimate === 0 ? "$" + formatMonetaryDecimal(this.state.response.order.quote.shippingCostEstimate) : "TBD")),
                                            React.createElement("tr", null,
                                                React.createElement("td", null, "Handling & Packaging"),
                                                React.createElement("td", { className: 'monetary' }, "$" + formatMonetaryDecimal(this.state.response.order.quote.handlingAndDryIce)))),
                                    this.state.response.order.lineItems.find(function (l) { return l.type === LineItemType.Tax; }) === undefined &&
                                        React.createElement("tr", null,
                                            React.createElement("td", null, "Sales Tax"),
                                            React.createElement("td", { className: 'monetary' }, "TBD"))))),
                        this.state.response.order.modified &&
                            React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'box', label: 'View original order', labelPosition: 'left' }) },
                                React.createElement(Modal.Header, null,
                                    "Order ",
                                    this.state.response.order.id,
                                    " (original)"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(Modal.Description, null, "Original order prior to any updates"),
                                    React.createElement(QuoteDisplay, { quote: this.state.response.order.quote }))))));
    };
    UserOrderPage.prototype.componentDidMount = function () {
        this.loadOrder();
        // TODO does this work at all? Can't see it showing up anywhere
        gtag('event', 'screen_view', {
            screen_name: 'Order details - user'
        });
    };
    return UserOrderPage;
}(React.PureComponent));
export default UserOrderPage;
var LineItemType;
(function (LineItemType) {
    LineItemType["Misc"] = "MISC";
    LineItemType["Tax"] = "TAX";
    LineItemType["ShippingHandling"] = "SHIPPING_HANDLING";
})(LineItemType || (LineItemType = {}));
var ItemWithReorderButton = /** @class */ (function (_super) {
    __extends(ItemWithReorderButton, _super);
    function ItemWithReorderButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onModalOpenClick = function () {
            _this.setState({ reorderModalOpen: true });
        };
        _this.onCancelModal = function () {
            _this.setState({ reorderModalOpen: false });
        };
        _this.state = {
            reorderModalOpen: false,
        };
        return _this;
    }
    ItemWithReorderButton.prototype.render = function () {
        var _this = this;
        var product;
        if (this.props.item.kit instanceof RnaFishKit) {
            product = 'RnaFish';
        }
        else if (this.props.item.kit instanceof RnaCishKit) {
            product = 'RnaCish';
        }
        var button = React.createElement(Button, { onClick: this.onModalOpenClick, icon: 'cart', label: 'Buy it again', labelPosition: 'left' });
        var renderWithCatalog = function (catalog) {
            return React.createElement(ReOrderFormHolder, { catalog: catalog, pricedKit: _this.props.item, itemIndex: _this.props.itemIndex, orderId: _this.props.orderId, onCancel: _this.onCancelModal });
        };
        return React.createElement(Segment, null,
            React.createElement(KitIndexHeader, { itemIndex: this.props.itemIndex, kit: this.props.item.kit }),
            React.createElement(KitDisplay, { pricedKit: this.props.item, displayBlastLink: false, admin: false }),
            React.createElement("div", { className: 'kit-buttons' },
                React.createElement(Modal, { closeIcon: true, open: this.state.reorderModalOpen, onClose: this.onCancelModal, size: 'large', trigger: button },
                    React.createElement(Modal.Header, null, "Buy it again"),
                    React.createElement(Modal.Content, null,
                        React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Orders, this.props.orderId, product), render: renderWithCatalog })))));
    };
    return ItemWithReorderButton;
}(React.PureComponent));
// An extra layer of component to be a convenient place to calculate the initial form state.
var ReOrderFormHolder = /** @class */ (function (_super) {
    __extends(ReOrderFormHolder, _super);
    function ReOrderFormHolder(props) {
        var _this = _super.call(this, props) || this;
        _this.setRnaFishFormState = buildEditFormStateHandlerForComponent('rnaFishFormState', _this);
        _this.setIhc2FormState = buildEditFormStateHandlerForComponent('ihc2FormState', _this);
        _this.setRnaCishConsumerFormState = buildEditFormStateHandlerForComponent('rnaCishConsumerFormState', _this);
        _this.setChromogenKitFormState = buildEditFormStateHandlerForComponent('chromogenKitFormState', _this);
        _this.setManualProConsumerKitFormState = buildEditFormStateHandlerForComponent('manualProConsumerKitFormState', _this);
        _this.onAddToCart = function () {
            _this.setState({
                loading: true
            }, function () {
                var kitBody;
                if (_this.props.pricedKit.kit instanceof RnaFishKit) {
                    kitBody = EditKitForm.serializeRnaFishKit(_this.state.rnaFishFormState);
                }
                else if (_this.rnaCishProKitCheck(_this.props.pricedKit.kit)) {
                    kitBody = ProKitForm.serializeProKit(_this.state.rnaCishConsumerFormState);
                }
                else if (_this.rnaCishChromogenOnlyKitCheck(_this.props.pricedKit.kit)) {
                    kitBody = ChromogenKitForm.serializeChromogenKit(_this.state.rnaCishConsumerFormState);
                }
                else if (_this.props.pricedKit.kit instanceof BundleOfKits) {
                    kitBody = ManualProConsumerKitForm.serializeManualProConsumerKit(_this.state.manualProConsumerKitFormState);
                }
                else {
                    kitBody = serializeIhc2Kit(_this.state.ihc2FormState);
                }
                postJsonWithAuthn('/cart/item', JSON.stringify(kitBody))
                    .then(function (resp) {
                    if (resp.ok) {
                        // added to cart; don't do anything more
                        _this.setRnaFishFormState(function () {
                            return {
                                errors: [],
                            };
                        }, function () {
                            _this.setState({
                                success: true,
                                loading: false,
                            });
                        });
                        resp.json().then(function (r) {
                            tagAddToCart(r);
                        }).catch(function (rej) {
                            console.error("Couldn't track adding to cart: " + rej);
                        });
                        return undefined;
                    }
                    else {
                        return resp.json();
                    }
                }).then(function (resp) {
                    if (resp !== undefined) {
                        _this.setRnaFishFormState(function () {
                            return {
                                errors: resp.errors,
                            };
                        }, function () {
                            _this.setState({
                                loading: false,
                            });
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't add to cart: " + rej);
                });
            });
        };
        _this.addReorderMessage = function (comment) {
            var commentPrefix = "Reordered from order " + _this.props.orderId + " kit #" + (_this.props.itemIndex + 1) + ".";
            return comment.length === 0 ? commentPrefix : commentPrefix + "\nOriginal comment:\n\n" + comment;
        };
        _this.rnaCishProKitCheck = function (bundle) {
            return bundle instanceof RnaCishKit && (bundle.probeSetComponent !== undefined || bundle.amplifierComponent !== undefined ||
                bundle.bufferComponent !== undefined);
        };
        _this.rnaCishChromogenOnlyKitCheck = function (kit) {
            return kit instanceof RnaCishKit && kit.chromogenComponent !== undefined &&
                kit.probeSetComponent === undefined && kit.amplifierComponent === undefined &&
                kit.bufferComponent === undefined;
        };
        // TODO this is ugly and duplicated with CartItemView
        var rnaFishFormState;
        var ihc2FormState;
        var rnaCishConsumerFormState;
        var chromogenKitFormState;
        var manualProConsumerKitFormState;
        if (props.pricedKit instanceof RnaFishPricedKit) {
            var initialState = rnaFishKitToFormState(props.catalog.rnaCatalog, props.pricedKit.kit);
            rnaFishFormState = __assign(__assign({}, initialState), { comment: _this.addReorderMessage(initialState.comment) });
            ihc2FormState = defaultIhc2FormState(_this.props.catalog.ihc2Catalog, false);
            rnaCishConsumerFormState = defaultEnzymaticIshFormState();
            chromogenKitFormState = defaultChromogenKitFormState();
            manualProConsumerKitFormState = defaultManualProConsumerFormState(_this.props.catalog.rnaCatalog);
        }
        else if (_this.rnaCishProKitCheck(props.pricedKit.kit)) {
            var initialState = rnaCishKitToProFormState(props.catalog.rnaCatalog, props.pricedKit.kit);
            rnaCishConsumerFormState = __assign(__assign({}, initialState), { comment: _this.addReorderMessage(initialState.comment) });
            rnaFishFormState = defaultFormState(props.catalog.rnaCatalog, false);
            ihc2FormState = defaultIhc2FormState(props.catalog.ihc2Catalog, true);
            chromogenKitFormState = defaultChromogenKitFormState();
            manualProConsumerKitFormState = defaultManualProConsumerFormState(_this.props.catalog.rnaCatalog);
        }
        else if (_this.rnaCishChromogenOnlyKitCheck(props.pricedKit.kit)) {
            var initialState = chromogenOnlyCishKitToConsumerFormState(props.catalog.rnaCatalog, props.pricedKit.kit);
            chromogenKitFormState = __assign(__assign({}, initialState), { comment: _this.addReorderMessage(initialState.comment) });
            rnaFishFormState = defaultFormState(props.catalog.rnaCatalog, false);
            ihc2FormState = defaultIhc2FormState(props.catalog.ihc2Catalog, true);
            rnaCishConsumerFormState = defaultEnzymaticIshFormState();
            manualProConsumerKitFormState = defaultManualProConsumerFormState(_this.props.catalog.rnaCatalog);
        }
        else if (_this.props.pricedKit instanceof PricedBundleOfKits) {
            var initialState = manualProKitToConsumerFormState(props.catalog.rnaCatalog, props.pricedKit.kit);
            manualProConsumerKitFormState = __assign(__assign({}, initialState), { comment: _this.addReorderMessage(initialState.comment) });
            rnaFishFormState = defaultFormState(props.catalog.rnaCatalog, false);
            ihc2FormState = defaultIhc2FormState(props.catalog.ihc2Catalog, true);
            rnaCishConsumerFormState = defaultEnzymaticIshFormState();
            chromogenKitFormState = defaultChromogenKitFormState();
        }
        else {
            var initialState = ihc2KitToFormState(props.catalog.ihc2Catalog, props.pricedKit.kit);
            ihc2FormState = __assign(__assign({}, initialState), { comment: _this.addReorderMessage(initialState.comment) });
            rnaFishFormState = defaultFormState(props.catalog.rnaCatalog, false);
            rnaCishConsumerFormState = defaultEnzymaticIshFormState();
            chromogenKitFormState = defaultChromogenKitFormState();
            manualProConsumerKitFormState = defaultManualProConsumerFormState(_this.props.catalog.rnaCatalog);
        }
        _this.state = {
            rnaFishFormState: rnaFishFormState,
            ihc2FormState: ihc2FormState,
            rnaCishConsumerFormState: rnaCishConsumerFormState,
            chromogenKitFormState: chromogenKitFormState,
            manualProConsumerKitFormState: manualProConsumerKitFormState,
            loading: false,
            success: false
        };
        return _this;
    }
    // TODO DOUBLE CHECK THIS
    ReOrderFormHolder.prototype.render = function () {
        var _this = this;
        var renderWithCatalog = function (catalog) {
            var formNode;
            if (_this.props.pricedKit instanceof RnaFishPricedKit) {
                formNode = React.createElement(EditKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.rnaFishFormState, restrictCustomTargetProbeSetSizeToCatalog: true, enableAmplifierCustomScale: false, enableProbeSetCustomScale: false, enableBufferCustomScale: false, loadPriceOnMount: true, enableCustomPrice: false, setFormState: _this.setRnaFishFormState, legacy: _this.props.pricedKit.kit.legacy, showErrors: true });
            }
            else if (_this.rnaCishProKitCheck(_this.props.pricedKit.kit)) {
                formNode = React.createElement("div", { className: 'consumer-edit-enzymatic-ish-form' },
                    React.createElement(ProKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.rnaCishConsumerFormState, kitConfigurations: [ProbeDetect, ProbeOnly, DetectOnly], loadPriceOnMount: true, setFormState: _this.setRnaCishConsumerFormState }));
            }
            else if (_this.rnaCishChromogenOnlyKitCheck(_this.props.pricedKit.kit)) {
                formNode = React.createElement("div", { className: 'consumer-edit-enzymatic-ish-form' },
                    React.createElement(ChromogenKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.chromogenKitFormState, setFormState: _this.setChromogenKitFormState, loadPriceOnMount: true }));
            }
            else if (_this.props.pricedKit instanceof PricedBundleOfKits) {
                formNode = React.createElement(ManualProConsumerKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.manualProConsumerKitFormState, loadPriceOnMount: true, restrictCustomTargetProbeSetSizeToCatalog: true, enableCustomPrice: false, enableAmplifierCustomScale: false, enableProbeSetCustomScale: false, enableBufferCustomScale: false, setFormState: _this.setManualProConsumerKitFormState, showErrors: true });
            }
            else {
                formNode = React.createElement(Ihc2EditKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: _this.props.catalog.ihc2Catalog, formState: _this.state.ihc2FormState, loadPriceOnMount: true, setFormState: _this.setIhc2FormState, legacy: _this.props.pricedKit.kit.legacy, showErrors: true });
            }
            return React.createElement(React.Fragment, null,
                !_this.state.success &&
                    React.createElement(React.Fragment, null,
                        React.createElement("p", null, "Note: previously ordered configurations may not be available in the current catalog and will have defaults applied as necessary."),
                        React.createElement(Form, { error: _this.state.rnaFishFormState.errors.length > 0 },
                            formNode,
                            React.createElement("div", { style: { 'textAlign': 'right' } },
                                React.createElement(Button, { icon: 'cancel', label: 'Cancel', labelPosition: 'left', onClick: _this.props.onCancel }),
                                React.createElement(Button, { disabled: _this.state.rnaFishFormState.errors.length > 0 || _this.state.success || _this.state.rnaFishFormState.priceLoading, className: ORIGIN === "hcr" ? "cish-button" : "", icon: 'cart plus', label: 'Add to cart', labelPosition: 'left', onClick: _this.onAddToCart, positive: true })))),
                _this.state.success &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Message, { positive: true },
                            React.createElement(Message.Header, null, "Kit added to cart")),
                        React.createElement("div", { style: { 'textAlign': 'right' } },
                            React.createElement(Button, { icon: 'arrow alternate circle left', label: 'Continue reordering', labelPosition: 'left', onClick: _this.props.onCancel }),
                            React.createElement(NavLink, { to: AppPaths.CART },
                                React.createElement(Button, { icon: 'cart', label: 'Proceed to cart', labelPosition: 'left', positive: true })))));
        };
        return React.createElement("div", null,
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Orders, this.props.orderId), render: renderWithCatalog }));
    };
    return ReOrderFormHolder;
}(React.PureComponent));
export var nicknameHelp = React.createElement(Help, null, "Use this field to give your order a nickname or provide other information that will make it easy for you to identify this order in your order history. If you change your mind, you can always edit the nickname later.");
export function nicknamePlaceholder() {
    return "For " + DateTime.local().plus(Duration.fromObject({ days: 30 })).toISODate() + " experiment";
}
var EditNicknameModal = /** @class */ (function (_super) {
    __extends(EditNicknameModal, _super);
    function EditNicknameModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onNicknameChange = function (event) {
            var value = event.currentTarget.value;
            _this.setState({
                nickname: value
            });
        };
        _this.onSave = function () {
            _this.props.postRequest("/user/orders/id/" + encodeURIComponent(_this.props.order.id) + "/nickname", {
                nickname: _this.state.nickname
            });
        };
        _this.state = {
            nickname: props.order.nickname
        };
        return _this;
    }
    EditNicknameModal.prototype.render = function () {
        // we don't actually validate the nickname or otherwise provide errors, but it's simple to just wire in the
        // normal error handling form field anyway to be consistent
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/nickname', errors: this.props.state.errors, required: false, labelContent: React.createElement(React.Fragment, null,
                    "Nickname ",
                    nicknameHelp) },
                React.createElement(TextArea, { onChange: this.onNicknameChange, 
                    // date 30 days ahead
                    placeholder: nicknamePlaceholder(), value: this.state.nickname })),
            React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Save', labelPosition: 'left', onClick: this.onSave, positive: true }));
    };
    return EditNicknameModal;
}(React.PureComponent));
var CancelOrderModal = /** @class */ (function (_super) {
    __extends(CancelOrderModal, _super);
    function CancelOrderModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onConfirm = function () {
            _this.props.postRequest("/user/orders/id/" + encodeURIComponent(_this.props.order.id) + "/cancel", {});
        };
        return _this;
    }
    CancelOrderModal.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.props.order.cancellable ?
            React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Yes', labelPosition: 'left', onClick: this.onConfirm, positive: true }) :
            React.createElement("p", { style: { fontWeight: 'bold' } },
                "The Molecular Instruments team is already working on your order. Please contact ",
                React.createElement("a", { href: "mailto:support@molecularinstruments.com" }, "support@molecularinstruments.com "),
                "for further assistance."));
    };
    return CancelOrderModal;
}(React.PureComponent));
//# sourceMappingURL=UserOrderPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/UserOrderPage.js
// module id = 574
// module chunks = 0